module.exports = __webpack_public_path__ + "static/media/med-combined.cf357356.jpg";